import {
  Mesh,
  PlaneGeometry,
  MeshStandardMaterial,
  Scene,
  TextureLoader,
  DoubleSide,
  RepeatWrapping,
  Vector2,
  sRGBEncoding,
  Float32BufferAttribute,
  SRGBColorSpace,
} from "three";
import PoolBorders from "./pool_borders";
import { Water } from "./water/water";


import normal1Tex from ".././textures/Water_1_M_Normal.jpg";
import notmal2Tex from ".././textures/Water_2_M_Normal.jpg";
import flowTex from ".././textures/Water_1_M_Flow.jpg";
import SceneManager from "../scene_mgr";

class WaterPlane {
  
  private water: Mesh;
  private poolBorders: PoolBorders;
  private poolType: string;
  private water2: Water;

  private normal1Tex: THREE.Texture;
  private normal2Tex: THREE.Texture;
  private flowTex: THREE.Texture;
  oversize: number = 0;
  private sceneMgr: SceneManager;
  private isInEditMode:boolean = false;

  private paramsStd = {
    color: "#8ED7F8",
    scale: 0.8,
    flowX: 0.4,
    flowY: 0.4,
  };

  private paramsPond = {
    color: "#5B907D",
    scale: 0.8,
    flowX: 0.4,
    flowY: 0.4,
  };

  private currentParam = this.paramsStd;

  constructor(poolBorders: PoolBorders, poolType: string, sceneManager: SceneManager) {
    this.sceneMgr = sceneManager;
    this.poolBorders = poolBorders;
    this.poolType = poolType;

    const textureLoader = new TextureLoader();
    this.normal1Tex = textureLoader.load(normal1Tex);
    this.normal1Tex.wrapS = this.normal1Tex.wrapT = RepeatWrapping;

    this.normal2Tex = textureLoader.load(notmal2Tex);
    this.normal2Tex.wrapS = this.normal2Tex.wrapT = RepeatWrapping;

    this.flowTex = textureLoader.load(flowTex);
    this.flowTex.wrapS = this.flowTex.wrapT = RepeatWrapping;

    this.createWaterPlane2();
  }

  addToScene(scene: Scene) {
    scene.add(this.water2);
  }

  removeFromScene(scene: Scene) {
    scene.remove(this.water2);
  }

  private createWaterPlane2() {
    const width = this.poolBorders.poolLength;
    const length = this.poolBorders.poolWidth;

    if (this.water2!=null) {
      this.removeFromScene(this.sceneMgr.scene);
      this.water2.geometry.dispose();
      this.water2=null;      
    }

    if (this.isInEditMode) return;

    const waterGeometry = new PlaneGeometry(width + this.oversize, length + this.oversize, 2, 2); // No subdivisions
    
    this.water2 = new Water(waterGeometry, {
      color: this.currentParam.color,
      scale: this.currentParam.scale,

      flowDirection: new Vector2(this.currentParam.flowX, this.currentParam.flowY),
      textureWidth: 1024,
      textureHeight: 1024,

      
      normalMap0: this.normal1Tex,
      normalMap1: this.normal2Tex,
      reflectivity: 0.2,
      flowSpeed: 0.05,
    });

    this.water2.rotation.x = -Math.PI / 2;
    this.water2.position.y = this.poolType == 'overflow' ? 0.06 : -0.03;
  
    if (this.poolType == 'overflow') {
      this.water2.position.y = 0.06;
    }
    else if (this.poolType == 'infinity') {
      this.water2.position.y = this.sceneMgr.margelleHeight + 0.02;
    }
    else {
      this.water2.position.y = -0.03;
    }

    this.water2.castShadow=false;
    this.water2.receiveShadow=false;
  }

  changePoolType(scene:Scene, poolType: string) {
    this.poolType = poolType;
    if (poolType == 'pond') {
      this.currentParam = this.paramsPond;
    }
    else {
      this.currentParam = this.paramsStd;
    }
    this.resize(scene);
  }

  resize(scene: Scene) {
    // Remove the old water mesh from the scene
    scene.remove(this.water2);

    // Create and add the new water mesh to the scene
    this.createWaterPlane2();
    if (this.water2!=null) scene.add(this.water2);
  }

  setEditMode(isEditMode: boolean, scene: Scene) {
  //  this.water2.visible = isEditMode;
    this.isInEditMode = isEditMode;
    this.resize(scene);
  }
}

export default WaterPlane;
